import { render, staticRenderFns } from "./LoadingSymbol.vue?vue&type=template&id=5bb07b9a&scoped=true"
import script from "./LoadingSymbol.vue?vue&type=script&lang=js"
export * from "./LoadingSymbol.vue?vue&type=script&lang=js"
import style0 from "./LoadingSymbol.vue?vue&type=style&index=0&id=5bb07b9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb07b9a",
  null
  
)

export default component.exports